import { memo } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { WHATSAPP_CHANNEL_AUTOMATIONS_IMPACT_COPY } from "../../management/constants/whatsappChannelAutomationsCopy";
import { WHATSAPP_CHANNEL_SECRETARY_AI_COPY } from "../../management/constants/whatsappChannelSecretaryAiCopy";

export interface ConfigurationOptionDialogsProps {
  isConfirmDialogOpen: boolean;
  isFluxmedConfirmOpen: boolean;
  onCancelConnectMeta: () => void;
  onConfirmConnectMeta: () => void;
  onCancelFluxmed: () => void;
  onConfirmFluxmed: () => void;
  /** Quando true, exibe aviso de remoção das automações personalizadas. */
  hasConfiguredAutomations?: boolean;
  /** Quando true, destaca que a Secretária IA será desligada. */
  hasSecretaryAgentActive?: boolean;
}

const ConfigurationOptionDialogs = memo((props: ConfigurationOptionDialogsProps) => {
  const {
    isConfirmDialogOpen,
    isFluxmedConfirmOpen,
    onCancelConnectMeta,
    onConfirmConnectMeta,
    onCancelFluxmed,
    onConfirmFluxmed,
    hasConfiguredAutomations = false,
    hasSecretaryAgentActive = false,
  } = props;

  const automationsImpactBlock = hasConfiguredAutomations ? (
    <>
      <DialogContentText color="text.primary" sx={{ mt: 2 }}>
        {WHATSAPP_CHANNEL_AUTOMATIONS_IMPACT_COPY.dialogParagraph}
      </DialogContentText>
      <DialogContentText color="warning.main" sx={{ mt: 1.5, fontWeight: 600 }}>
        {WHATSAPP_CHANNEL_AUTOMATIONS_IMPACT_COPY.dialogHighlight}
      </DialogContentText>
      <DialogContentText color="text.secondary" sx={{ mt: 1 }}>
        {WHATSAPP_CHANNEL_AUTOMATIONS_IMPACT_COPY.dialogSystemDefaultsNote}
      </DialogContentText>
    </>
  ) : null;

  return (
    <>
      <Dialog
        open={isConfirmDialogOpen}
        onClose={onCancelConnectMeta}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Aviso Importante</DialogTitle>
        <DialogContent>
          <DialogContentText color="text.primary">
            A extensão Fluxmed será desativada caso você vincule a conta do
            Facebook.
          </DialogContentText>
          <DialogContentText color="error" sx={{ mt: 2, fontWeight: 500 }}>
            As mensagens previamente contratadas estarão disponíveis em caso
            alteração de plano.
          </DialogContentText>
          {automationsImpactBlock}
          <DialogContentText sx={{ mt: 2 }}>
            Deseja continuar?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button type="button" onClick={onCancelConnectMeta} color="inherit">
            Cancelar
          </Button>
          <Button type="button" onClick={onConfirmConnectMeta} color="primary" variant="contained">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isFluxmedConfirmOpen}
        onClose={onCancelFluxmed}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Alterar canal de envio?</DialogTitle>
        <DialogContent>
          <DialogContentText color="text.primary">
            Ao selecionar a opção Fluxmed, a integração com o{" "}
            <strong>Meta Business será desabilitada</strong> e não poderá ser
            mais utilizada enquanto esta opção estiver ativa.
          </DialogContentText>
          <DialogContentText color="text.secondary" sx={{ mt: 1.5 }}>
            {WHATSAPP_CHANNEL_SECRETARY_AI_COPY.always}
          </DialogContentText>
          {hasSecretaryAgentActive ? (
            <DialogContentText
              color="warning.main"
              sx={{ mt: 1.5, fontWeight: 600 }}
            >
              {WHATSAPP_CHANNEL_SECRETARY_AI_COPY.whenActive}
            </DialogContentText>
          ) : null}
          {automationsImpactBlock}
          <DialogContentText sx={{ mt: 2 }}>
            Deseja continuar?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button type="button" onClick={onCancelFluxmed} color="inherit">
            Cancelar
          </Button>
          <Button type="button" onClick={onConfirmFluxmed} color="primary" variant="contained">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
});

ConfigurationOptionDialogs.displayName = "ConfigurationOptionDialogs";

export default ConfigurationOptionDialogs;
